<template>
    <div class="top">
        <!-- 头部按钮和logo -->
        <el-menu class="el-menu-demo" mode="horizontal" :default-active="route" router>
            <el-menu-item index="/home">
                <template slot="title">
                    <el-image src="https://game-cdn.feigo.fun/uploads/20201106/f3BLKg74KjpiYcHIsa9z4p4wkqF8e37f.png" fit="cover" class="logo"></el-image>
                </template>
            </el-menu-item>
            <el-menu-item index="/home">首页</el-menu-item>
            <el-menu-item index="/about">关于风领</el-menu-item>
            <el-menu-item index="/productList">游戏产品</el-menu-item>
            <el-menu-item index="/business">商务合作</el-menu-item>
            <el-menu-item index="/join">加入我们</el-menu-item>
        </el-menu>

        <!-- 轮播图 -->
        <el-carousel :height="height + 'px'" class="carousels" :arrow="arrow" :indicator-position="position">
            <el-carousel-item
                v-for="(item, index) in images"
                :key="index"
                :style="{
                    'background-image': 'url(' + item.url + ')',
                    'background-size': '100% 100%'
                }"
                class="carousel"
            >
                <div class="gary-cls">
                    <div class="font-cls" v-show="route == '/home'">
                        <div class="top-size">{{ item.content1 }}</div>
                        <div class="bottom-size">
                            {{ item.content2 }}
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                {
                    url: require('@/common/imgs/tcCfMn2JStiEAl5fEqTk70Is9ZO3V7D5.png'), //+ Date.parse(new Date())
                    content1: '专业 可信赖',
                    content2: '我们致力于成为专业、可信赖的小游戏制作平台，助力小游戏生态健康发展'
                },
                {
                    url: require('@/common/imgs/pKlOe7dvjpt8A8SQ3B1wegYgewHm2fAc.png'),
                    content1: '释放创意 创造快乐',
                    content2: '让玩家获得简单快乐，成为一家走心的企业'
                },
                {
                    url: require('@/common/imgs/JKiC1e8TxL0AUqOb4kbOn19OvgJfoCJc.png'),
                    content1: '创造精彩游戏生活',
                    content2: '展现优质创意，丰富文娱生活'
                },
                {
                    url: require('@/common/imgs/uJETB0x3LrbWOg1lRXU69Tlxg1IQUFFX.png'),
                    content1: '人人倚重 共同成长',
                    content2: '把个人的追求融入到企业的长远发展之中，无论身处哪个工作岗位，都是风领科技非常重要一员'
                }
            ],
            activeIndex: '/home'
        };
    },
    props: {
        height: Number,
        route: String,
        arrow: String,
        position: String
    },
    created() {}
};
</script>

<style   src='../css/rotaion.css'>
</style>